// extracted by mini-css-extract-plugin
export var anchorDestination = "serializers-module--anchorDestination--5d4f7";
export var bannerVariant = "serializers-module--bannerVariant--66110";
export var callToAction = "serializers-module--callToAction--aad1a";
export var callout = "serializers-module--callout--8bd04";
export var decorativeSpan = "serializers-module--decorativeSpan--d1bef";
export var portableTable = "serializers-module--portableTable--f4f60";
export var quoteText = "serializers-module--quoteText--c0fbd";
export var reactPlayerContainer = "serializers-module--reactPlayerContainer--47094";
export var removeLinkUnderline = "serializers-module--removeLinkUnderline--c1d25";
export var textLink = "serializers-module--textLink--08663";